import { now } from "../utils/time";

export class Work {
    public static calcClientLastConvertTime(energyValue: number, storeSpeed: number): number {
        return now() - Math.ceil(energyValue / storeSpeed);
    }
}